function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-145.4 425.7c0-.4.3-.7.7-.7h2.2c.4 0 .7.2.7.7.2 6 3.3 8.9 8.9 8.9 5 0 8-2.8 8-7.2 0-10.6-20.2-7-20.2-20.7 0-5.9 4.6-10.6 11.5-10.6 7.4 0 11.5 4.5 11.8 11.4 0 .4-.2.7-.6.7h-2.3c-.4 0-.6-.2-.6-.7-.2-4.7-3.1-7.9-8-7.9-4.7 0-8 2.8-8 7.1 0 10.5 20.3 6.8 20.3 20.7 0 6-4.9 10.7-11.6 10.7-7.8-.1-12.5-4.8-12.8-12.4zm30.8-.3v-16.6c0-7.5 4.8-12.8 11.9-12.8 6.9 0 11.5 4.7 11.9 11.4 0 .4-.2.7-.6.7h-2.3c-.4 0-.6-.2-.6-.7-.3-4.7-3.4-7.9-8.3-7.9-5.1 0-8.3 3.7-8.3 9.3v16.6c0 5.4 3.2 9.1 8.4 9.1 5 0 8.2-3.6 8.4-8.9 0-.5.3-.7.7-.7h2.2c.4 0 .7.2.7.7-.4 7.2-5.1 12.3-12.1 12.3-7.1.1-12-5.2-12-12.5zm32 11.2V409c0-7.5 5.4-12.6 12.6-12.6h3.2c.4 0 .7.3.7.7v2.1c0 .4-.3.7-.7.7H-70c-5.3 0-8.9 3.5-8.9 9.1v27.6c0 .4-.3.7-.7.7h-2.2c-.5 0-.8-.3-.8-.7zm19.9-11.2v-16.8c0-7.3 4.7-12.6 12.1-12.6 7.2 0 12.1 5.4 12.1 12.3 0 6.7-4.7 11.8-12.7 11.8h-7.9v5.4c0 5.2 2.9 9.1 8.4 9.1 5.2 0 8.2-3.7 8.4-8.9 0-.4.3-.7.7-.7h2.2c.4 0 .7.2.7.7-.2 7.2-4.8 12.3-12 12.3-7.5-.1-12-5.3-12-12.6zm11.5-8.8c5.9 0 9-3.5 9-8.3 0-5-3.2-8.9-8.4-8.9-5.4 0-8.4 3.7-8.4 9.2v8h7.8zm20.1 8.8v-16.8c0-7.3 4.7-12.6 12.1-12.6 7.2 0 12.1 5.4 12.1 12.3 0 6.7-4.7 11.8-12.7 11.8h-7.9v5.4c0 5.2 2.9 9.1 8.4 9.1 5.2 0 8.2-3.7 8.4-8.9 0-.4.3-.7.7-.7h2.2c.4 0 .7.2.7.7-.2 7.2-4.8 12.3-12 12.3-7.5-.1-12-5.3-12-12.6zm11.5-8.8c5.9 0 9-3.5 9-8.3 0-5-3.2-8.9-8.4-8.9-5.4 0-8.4 3.7-8.4 9.2v8h7.8zm20.6 20v-27.8c0-7.4 4.5-12.8 11.8-12.8 7.2 0 11.8 5.4 11.8 12.8v27.9c0 .4-.3.7-.7.7h-2.2c-.4 0-.7-.2-.7-.7v-27.9c0-5.6-2.8-9.4-8.1-9.4s-8.1 3.8-8.1 9.4v27.9c0 .4-.3.7-.7.7H1.9c-.6-.1-.9-.4-.9-.8zm31.6-10.9c0-.4.3-.7.7-.7h2.2c.4 0 .7.2.7.7.2 6 3.3 8.9 8.9 8.9 5 0 8-2.8 8-7.2 0-10.6-20.2-7-20.2-20.7 0-5.9 4.6-10.6 11.5-10.6 7.4 0 11.5 4.5 11.8 11.4 0 .4-.2.7-.6.7h-2.3c-.4 0-.6-.2-.6-.7-.2-4.7-3.1-7.9-8-7.9-4.7 0-8 2.8-8 7.1 0 10.5 20.3 6.8 20.3 20.7 0 6-4.9 10.7-11.6 10.7-7.7-.1-12.5-4.8-12.8-12.4z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: 88.441,
  y1: 441.225,
  x2: 125.715,
  y2: 376.664,
  gradientTransform: "matrix(1 0 0 -1 0 796.4)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.243,
  stopColor: "#31c4f3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.355,
  stopColor: "#31beef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#2ab1e6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.717,
  stopColor: "#1e9cd7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.938,
  stopColor: "#1281c4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0d7abe"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M140.7 395.9v-.8c0-.4-.1-.7-.1-1.1 0-.2-.1-.5-.1-.7-.1-.4-.2-.7-.3-1.1-.1-.2-.1-.5-.2-.7-.1-.3-.2-.7-.3-1-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.4-.8-.1-.3-.3-.6-.5-.9-.1-.2-.2-.4-.4-.6-.2-.3-.4-.7-.6-1-.1-.2-.3-.4-.4-.6-.2-.3-.5-.6-.7-.9-.2-.2-.3-.4-.5-.6l-.7-.7-.7-.7c-.2-.2-.4-.3-.6-.5-.3-.3-.6-.5-1-.7-.1-.1-.2-.2-.3-.2L101.8 360c-8.6-6-20.4-3.8-26.4 4.8s-3.8 20.4 4.8 26.4l8.3 5.7 13.8 9.6c.3.2.5.3.7.5 4 2.9 6.7 7.7 6.7 13.1 0 4.8-2.1 9-5.4 12l28-19.4.3-.2 1.5-1.2 1.2-1.2.3-.3c.4-.4.7-.8 1-1.2.1-.1.2-.2.3-.4.2-.3.4-.6.6-.8.2-.3.4-.7.6-1 .1-.2.2-.4.4-.6.2-.3.3-.6.5-.9.1-.3.3-.5.4-.8.1-.3.2-.5.3-.8.1-.3.2-.7.3-1 .1-.2.1-.5.2-.7.1-.4.2-.7.3-1.1 0-.2.1-.5.1-.7.1-.4.1-.7.1-1.1v-1.8c.1-.3.1-.7 0-1z",
  fill: "url(#a)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M103.1 407l-14.6-10.1-8.3 5.7c-8.6 6-10.8 17.8-4.8 26.4 3.7 5.3 9.6 8.2 15.6 8.2 3.3 0 6.6-.9 9.6-2.7.4-.2.8-.5 1.1-.7l2.6-1.8c3.3-3 5.4-7.2 5.4-12 .1-5.4-2.6-10.1-6.6-13z",
  fill: "#aee0f9"
});

function SvgScreensFullInverseColorLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-154 350.2 302.1 93.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreensFullInverseColorLogo);
export default __webpack_public_path__ + "static/media/screens-full-inverse-color-logo.c9ec1337.svg";
export { ForwardRef as ReactComponent };